import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { Layout } from '../components/Layout'
import { hasAnyRole } from '../utils/permissions'
import { Users, School, Bell, FileText } from 'lucide-react'
import { Link } from 'react-router-dom'

const Dashboard = () => {
  const { userProfile, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Yükleniyor...</div>
      </div>
    )
  }

  if (!userProfile) {
    return <Navigate to="/login" replace />
  }

  const isAdmin = hasAnyRole(userProfile, ['super_admin', 'admin'])
  const isMudur = hasAnyRole(userProfile, ['mudur'])

  return (
    <Layout>
      <div>
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Hoş Geldiniz
          </h1>
          <p className="text-gray-600">
            {userProfile.full_name || userProfile.email}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {isAdmin && (
            <>
              <Link
                to="/admin/users"
                className="group bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md hover:border-blue-300 transition-all duration-200"
              >
                <div className="flex items-center space-x-4">
                  <div className="p-3 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl group-hover:scale-110 transition-transform">
                    <Users className="w-6 h-6 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors">
                      Kullanıcı Yönetimi
                    </h3>
                    <p className="text-sm text-gray-500 mt-1">
                      Kullanıcıları görüntüle ve yönet
                    </p>
                  </div>
                </div>
              </Link>

              <Link
                to="/admin/schools"
                className="group bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md hover:border-green-300 transition-all duration-200"
              >
                <div className="flex items-center space-x-4">
                  <div className="p-3 bg-gradient-to-br from-green-500 to-green-600 rounded-xl group-hover:scale-110 transition-transform">
                    <School className="w-6 h-6 text-white" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-900 group-hover:text-green-600 transition-colors">
                      Okul Yönetimi
                    </h3>
                    <p className="text-sm text-gray-500 mt-1">
                      Okulları görüntüle ve yönet
                    </p>
                  </div>
                </div>
              </Link>
            </>
          )}

          <Link
            to="/notifications/create"
            className="group bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md hover:border-yellow-300 transition-all duration-200"
          >
            <div className="flex items-center space-x-4">
              <div className="p-3 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-xl group-hover:scale-110 transition-transform">
                <Bell className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-gray-900 group-hover:text-yellow-600 transition-colors">
                  Bildirim Gönder
                </h3>
                <p className="text-sm text-gray-500 mt-1">
                  Yeni bildirim oluştur
                </p>
              </div>
            </div>
          </Link>

          {isMudur && (
            <Link
              to="/mudur/notifications"
              className="group bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md hover:border-purple-300 transition-all duration-200"
            >
              <div className="flex items-center space-x-4">
                <div className="p-3 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl group-hover:scale-110 transition-transform">
                  <FileText className="w-6 h-6 text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-900 group-hover:text-purple-600 transition-colors">
                    Bildirimlerim
                  </h3>
                  <p className="text-sm text-gray-500 mt-1">
                    Gelen bildirimleri görüntüle
                  </p>
                </div>
              </div>
            </Link>
          )}
        </div>

        <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900 mb-6">
            Kullanıcı Bilgileri
          </h2>
          <dl className="grid grid-cols-1 gap-6 sm:grid-cols-2">
            <div>
              <dt className="text-sm font-medium text-gray-500 mb-1">E-posta</dt>
              <dd className="text-sm font-medium text-gray-900">{userProfile.email}</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500 mb-1">Ad Soyad</dt>
              <dd className="text-sm font-medium text-gray-900">
                {userProfile.full_name || '-'}
              </dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500 mb-1">Rol</dt>
              <dd className="text-sm font-medium text-gray-900">
                {userProfile.role?.display_name || '-'}
              </dd>
            </div>
            {userProfile.school && (
              <div>
                <dt className="text-sm font-medium text-gray-500 mb-1">Okul</dt>
                <dd className="text-sm font-medium text-gray-900">
                  {userProfile.school.okul_adi}
                </dd>
              </div>
            )}
          </dl>
        </div>
      </div>
    </Layout>
  )
}

export default Dashboard



